import { render, staticRenderFns } from "./PatientStance.vue?vue&type=template&id=4314c44e&scoped=true&"
import script from "./PatientStance.vue?vue&type=script&lang=js&"
export * from "./PatientStance.vue?vue&type=script&lang=js&"
import style0 from "./PatientStance.vue?vue&type=style&index=0&id=4314c44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4314c44e",
  null
  
)

export default component.exports